import React, { Component } from 'react';
import { withLanguageContext } from '../../../utils/LanguageContext';
import { JoinQr } from '../../templates';

import './styles.css';

/**
 * JoinQrView section of landing
 *
 * @typedef {Object} Props
 * @prop {Object} [content]
 *
 * @augments {Component<Props>}
 */
class JoinQrView extends Component {

	render () {

		const {
			heading,
			subHeading,
			pilotProgramPoints,
			image,
			callToActionText,
			callToActionBtnText,
			href,
		} = this.props.content.qrLandingPage.joinQr;

		return (
			<JoinQr
				pilotProgramPoints={pilotProgramPoints}
				heading={heading}
				subHeading={subHeading}
				className='HowQrWorksView'
				image={image}
				callToActionText={callToActionText}
				callToActionBtnText={callToActionBtnText}
				href={href}
				imageClassName='imageCustomClassName'
			/>
		);
	}

}

export default withLanguageContext(JoinQrView);



// WEBPACK FOOTER //
// ./src/components/views/JoinQrView/JoinQrView.js